import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import option3 from '~/images/financing-options/finance2.png';
import rentingImg from '~/images/financing-options/Renting.png';
import Image from 'next/image';
import CoorpLayout, {
  Title,
  Text,
  SubTitle,
} from '@/components/layout/CoorpLayout';
import { useRouter } from 'next-translate-routes-multi-domain';
import { gtagContactEvent } from '@/lib/utilities/analytics/gtm';

export default function FinancingOptionsPage() {
  const { t } = useTranslation('products');
  const { locale } = useRouter();
  return (
    <CoorpLayout
      headingOne={t('products:CORPORATE_FINANCING_OPTIONS_H1')}
      headingTwo={t('products:CORPORATE_FINANCING_OPTIONS_H2')}
      headingThree={t('products:CORPORATE_FINANCING_OPTIONS_H3_HERO')}
      breadcrubPages={[
        {
          name: t('products:CORPORATE_FINANCING_OPTIONS_H1'),
          href: '/financing-options',
        },
      ]}
    >
      <Title title={t('products:CORPORATE_FINANCING_OPTIONS_TITLE')} />
      <Text text={t('products:CORPORATE_FINANCING_OPTIONS_P1')} />
      {locale === 'es-ES' && (
        <>
          <hr className='mt-11 md:mt-6' />
          <div className='my-6 grid grid-cols-1 gap-4 md:grid-cols-2'>
            <Image
              src={rentingImg}
              alt={t('products:CORPORATE_FINANCING_OPTIONS_ITEM_1')}
              objectFit='cover'
            />
            <div className='mt-4 md:mt-9'>
              <SubTitle title={'Renting a 36 o 60 meses'} />
              <Text
                text={
                  'Trabajamos con múltiples partners para ofrecer el mínimo interés y una cuota más ajustada'
                }
              />
              <a
                href={
                  'mailto:' + t('products:HEADER_SUPPORT_CONTACT_WITH_US_EMAIL')
                }
                onClick={gtagContactEvent}
                className='font-semibold'
              >
                <Text
                  text={t('products:CORPORATE_SUPPORT_CONTACT_WITH_US_EMAIL')}
                />
              </a>
            </div>
          </div>
        </>
      )}
      <hr className='mt-12' />
      <div className='mb-11 mt-6 grid grid-cols-1 gap-6 md:grid-cols-2'>
        <Image
          src={option3}
          alt={t('products:CORPORATE_FINANCING_OPTIONS_ITEM_2')}
          objectFit='cover'
        />
        <div className='mt-4 md:mt-9'>
          <SubTitle title={t('products:CORPORATE_FINANCING_OPTIONS_ITEM_2')} />
          <Text text={t('products:CORPORATE_FINANCING_OPTIONS_ITEM_2_TEXT')} />
          <a
            href={
              'mailto:' + t('products:HEADER_SUPPORT_CONTACT_WITH_US_EMAIL')
            }
            className='font-semibold'
          >
            <Text
              text={t('products:CORPORATE_SUPPORT_CONTACT_WITH_US_EMAIL')}
            />
          </a>
        </div>
      </div>
    </CoorpLayout>
  );
}
